export const PERMISSIONS_URL = '/account/roles/';
